<div class="message-container {{inputBorderClasses[borderStyle]}}" (clickOutside)="onClickOutside()" [ngClass]="{'error': error, 'focused': inputFocused}">
    <textarea #smashTextarea autocomplete="nope" type="text" [placeholder]="placeholder" [(ngModel)]="value" autosize>{{ value }}</textarea>
</div>